// extracted by mini-css-extract-plugin
export default {"totalItem":"production_totalItem__T4HLg","totalLabel":"production_totalLabel__fOURX"};